
import './App.css';
import Dictionary from './Dictionary';

export default function App() {
  return (
    <div className="App">
      <div className = "container">
      <header className="App-header">
     <h1>Dictionary</h1>
       
      </header></div>
      <Dictionary/> 
      <footer>Coded by <a href="https://github.com/Daria888-hub/myfirstreact"> Daria Lee</a> hosted on <a href="https://laughing-leakey-e36757.netlify.app/">netlify</a> </footer>
    
    </div>
  );
}


